import tokenImage from "../assets/img/Token_NAU.webp";

const TokenImageNAU: React.FC = () => {
  const handleClick = () => {
    window.open(
      "https://basescan.org/token/0x1A7F059f6Bc234D1D03075B430e26c67856B53dE",
      "_blank"
    );
  };

  return (
    <img
      src={tokenImage}
      alt="NAU"
      className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-full shadow-md hover:shadow-xl hover:scale-105 transition duration-300 ease-in-out"
      onClick={handleClick}
    />
  );
};

export default TokenImageNAU;
